module.exports = __webpack_public_path__ + "static/img/DNA提取+PCR扩增+测序banner.b628166.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/二级标题Banner/DNA提取+PCR扩增+测序banner.jpg
// module id = z+4w
// module chunks = 1